import { neutral } from '@bloomfieldrobotics/canopy';
import { styled, TableCell, TableCellProps } from '@mui/material';

export const SettingsTableCell = styled(TableCell)<TableCellProps>(
  ({ theme }) => ({
    borderBottom: '0.5px solid',
    borderColor: neutral[800],
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    height: '2rem',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '142%',
    textTransform: 'capitalize',
    textWrap: 'nowrap',
  })
);
